import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, DollarSign } from 'lucide-react';
export function NumbersSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-146">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-147">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-10 text-center uppercase" data-id="element-148">
          Hablemos de números reales
        </h2>

        <div className="space-y-6 mb-12" data-id="element-149">
          <div className="bg-zinc-900/80 border border-zinc-800 p-6 md:p-8 rounded-2xl flex flex-col md:flex-row gap-6 items-center md:items-start" data-id="element-150">
            <div className="bg-amber-500/10 p-4 rounded-full text-amber-500 shrink-0" data-id="element-151">
              <DollarSign className="w-8 h-8" data-id="element-152" />
            </div>
            <div data-id="element-153">
              <p className="text-xl text-zinc-200 leading-relaxed" data-id="element-154">
                Si recuperás solo{' '}
                <span className="text-amber-400 font-bold" data-id="element-155">
                  2 cancelaciones por semana
                </span>{' '}
                ya estás recuperando más de{' '}
                <span className="text-white font-bold bg-zinc-800 px-2 py-1 rounded" data-id="element-156">
                  $100.000 al mes
                </span>
                .
              </p>
            </div>
          </div>

          <div className="bg-zinc-900/80 border border-zinc-800 p-6 md:p-8 rounded-2xl flex flex-col md:flex-row gap-6 items-center md:items-start" data-id="element-157">
            <div className="bg-amber-500/10 p-4 rounded-full text-amber-500 shrink-0" data-id="element-158">
              <TrendingUp className="w-8 h-8" data-id="element-159" />
            </div>
            <div data-id="element-160">
              <p className="text-xl text-zinc-200 leading-relaxed" data-id="element-161">
                Si aumentás apenas{' '}
                <span className="text-amber-400 font-bold" data-id="element-162">
                  $2.000 el promedio
                </span>{' '}
                por cliente tu ingreso cambia fuerte{' '}
                <span className="text-white font-bold border-b-2 border-amber-500" data-id="element-163">
                  sin trabajar más horas
                </span>
                .
              </p>
            </div>
          </div>
        </div>

        <div className="text-center bg-amber-500 text-zinc-950 p-8 rounded-2xl shadow-xl" data-id="element-164">
          <p className="text-2xl md:text-3xl font-heading font-bold uppercase mb-2" data-id="element-165">
            No necesitás más clientes.
          </p>
          <p className="text-4xl md:text-5xl font-heading font-black uppercase tracking-tight" data-id="element-166">
            Necesitás orden.
          </p>
        </div>
      </motion.div>
    </section>;
}